<template>
  <div>
    <!-- Form Modal -->
    <b-modal
      id="modal-season-form"
      ref="myModal"
      centered
      no-close-on-backdrop
      no-close-on-esc
      size="md"
      @ok="submit"
    >
      <!-- Custom Modal Header -->
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <h5 v-if="grade.id === null">
          Register Grade
        </h5>
        <h5 v-if="grade.id !== null">
          Edit Grade
        </h5>

        <feather-icon
          class="ml-4 pr-0 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="close()"
        />
      </template>

      <!-- Custom Modal Footer -->
      <template #modal-footer="{ ok, cancel }">
        <b-button
          size="md"
          variant="primary"
          :disabled="saving"
          @click="ok()"
        >
          <b-spinner
            v-if="saving"
            small
            class="mr-1"
            label="Small Spinner"
          />
          <span v-if="!saving">Save</span>
          <span v-if="saving">Saving...</span>
        </b-button>
        <b-button
          size="md"
          variant="outline-secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>

      <!-- Data Form in Modal Body -->
      <template #default="{}">
        <validation-observer
          ref="dataForm"
          #default="{ invalid }"
        >
          <b-form
            ref="form"
            @submit.stop.prevent="handleCreate"
          >
            <b-row>
              <b-col
                cols="12"
                md="7"
              >
                <b-form-group
                  label-for="season_id"
                  label="Season"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Season"
                    rules=""
                  >
                    <b-form-select
                      id="season_id"
                      v-model="grade.season_id"
                      name="season_id"
                      size="sm"
                      disabled
                    >
                      <b-form-select-option
                        v-for="season in seasons"
                        v-if="season.isRunning"
                        :key="season.id"
                        :value="season.id"
                      >
                        {{ season.startYear }}/{{ season.endYear }}
                      </b-form-select-option>
                    </b-form-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.season_id"
                      class="text-danger"
                    >{{ serverErrors.season_id[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="5"
              >
                <b-form-group
                  label-for="type"
                  label="Grade Type"
                  :disabled="client.type !== 0"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Type"
                    rules=""
                  >
                    <b-form-select
                      id="type"
                      v-model="grade.type"
                      name="type"
                      size="sm"
                    >
                      <b-form-select-option :value="null">
                        Select...
                      </b-form-select-option>
                      <b-form-select-option :value="1">
                        National Grade
                      </b-form-select-option>
                      <b-form-select-option :value="2">
                        Company Grade
                      </b-form-select-option>
                    </b-form-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.type"
                      class="text-danger"
                    >{{ serverErrors.type[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="7">
                <b-form-group
                  labe-for="name"
                  label="Name"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Name"
                    rules=""
                  >
                    <b-form-input
                      id="name"
                      v-model="grade.name"
                      name="name"
                      size="sm"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.name"
                      class="text-danger"
                    >{{
                      serverErrors.name[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                v-if="grade.type != 2"
                cols="5"
              >
                <b-form-group
                  labe-for="price"
                  label="Price"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Price"
                    rules=""
                  >
                    <b-form-input
                      id="price"
                      v-model="grade.price"
                      name="price"
                      size="sm"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.price"
                      class="text-danger"
                    >{{
                      serverErrors.price[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col
                v-if="grade.type == 2"
                cols="5"
              >
                <b-form-group
                  labe-for="code"
                  label="CODE"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="CODE"
                    rules=""
                  >
                    <b-form-input
                      id="code"
                      v-model="grade.code"
                      name="code"
                      size="sm"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.code"
                      class="text-danger"
                    >{{ serverErrors.code[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label-for="variety"
                  label="Varities"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="variety"
                    rules=""
                  >
                    <b-form-select
                      id="variety"
                      v-model="grade.variety"
                      name="variety"
                      size="sm"
                    >
                      <b-form-select-option :value="null">
                        Select...
                      </b-form-select-option>
                      <b-form-select-option value="F">
                        Flue Cured
                      </b-form-select-option>
                      <b-form-select-option value="S">
                        Sun Cured
                      </b-form-select-option>
                      <b-form-select-option value="B">
                        Burley
                      </b-form-select-option>
                      <b-form-select-option value="D">
                        Dark Fired
                      </b-form-select-option>
                    </b-form-select>
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.variety"
                      class="text-danger"
                    >{{ serverErrors.variety[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-checkbox
                  v-model="grade.isActive"
                  :checked="grade.isActive"
                  class="custom-control-success"
                  name="status"
                  switch
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="CheckCircleIcon" />
                  </span>
                  <span>Active</span>
                </b-form-checkbox>
              </b-col>
              <b-col>
                <b-form-checkbox
                  v-model="grade.payable"
                  :checked="grade.payable"
                  class="custom-control-success"
                  name="status"
                  switch
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="CheckCircleIcon" />
                  </span>
                  <span>Is payable</span>
                </b-form-checkbox>
              </b-col>
            </b-row>

            <!-- <b-card>
                            {{ grade }}
                        </b-card> -->
          </b-form>
        </validation-observer>
      </template>
    </b-modal>
    <!-- ./Form Modal -->

    <!-- Filters -->
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col
            cols="6"
            md="2"
          >
            <label>Season</label>
            <b-form-select
              v-model="grade.season_id"
              size="sm"
              disabled
              @change="changeSeason()"
            >
              <b-form-select-option
                v-for="season in seasons"
                v-if="season.isRunning"
                :key="season.id"
                :value="season.id"
              >
                {{ season.startYear }}/{{ season.endYear }}
              </b-form-select-option>
            </b-form-select>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <!-- ./Filters -->

    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50 select-size-sm"
            />
            <label>entries</label>
          </b-col>
          <!-- ./Per Page -->

          <!-- Search & Button -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
                size="sm"
              />
              <b-button
                variant="primary"
                size="sm"
                @click="invokeCreateForm()"
              >
                <span class="text-nowrap">Register Grade</span>
              </b-button>
            </div>
          </b-col>
          <!-- ./Search & Button-->
        </b-row>
        <!-- ./Table Top -->
      </div>

      <!-- Table -->
      <b-table
        ref="records"
        :busy="isBusy"
        striped
        hover
        small
        class="position-relative"
        :items="fetch"
        responsive
        :fields="columns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(isActive)="data">
          <b-badge
            pill
            :variant="`light-${resolveStatusVariant(data.item.isActive)}`"
            class="text-capitalize"
          >
            <span v-if="!data.item.isActive">Blocked</span>
            <span v-else>Active</span>
          </b-badge>
        </template>

        <template #cell(prices)="data">
          <span v-if="data.item.prices.length > 0">{{ data.item.prices[data.item.prices.length - 1].value }}</span>
        </template>

        <template #cell(currency)="data">
          <span v-if="data.item.prices.length > 0">{{ data.item.prices[data.item.prices.length - 1].currency.abbreviation }}</span>
        </template>

        <template #cell(variety)="data">
          <span v-if="data.item.variety == 'F'">FCV</span>
          <span v-if="data.item.variety == 'B'">Burley</span>
          <span v-if="data.item.variety == 'D'">DFC</span>
          <span v-if="data.item.variety == 'S'">SC</span>
        </template>

        <template #cell(type)="data">
          <span v-if="data.item.type == 1">National</span>
          <span v-if="data.item.type == 2">Company</span>
        </template>

        <template #cell(payable)="data">
          <span v-if="data.item.payable == true">Yes</span>
          <span v-if="data.item.payable == false">No</span>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item @click="invokeUpdateForm(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item @click="remove(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <!-- Table Footer -->
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ from }} to {{ to }} of {{ totalRecords }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRecords"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
    BRow, BCol, BCard, BCardHeader, BCardBody, BTable, BPagination,
    BForm, BFormGroup,
    BButton, BFormSelect, BFormSelectOption, BFormInput, BDropdown, BDropdownItem, BFormDatepicker, BFormCheckbox,
    BSpinner, BBadge,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import store from '@/store'
import { ref, onUnmounted, onMounted } from '@vue/composition-api'
import gradesStoreModule from '@/views/cromis/grades/crop_grades/gradesStoreModule'
import useGradesList from '@/views/cromis/grades/crop_grades/useGradesList'

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BCardHeader,
        BCardBody,
        BTable,
        BPagination,
        BForm,
        BFormGroup,
        BButton,
        BFormSelect,
        BFormSelectOption,
        BFormInput,
        vSelect,
        BDropdown,
        BDropdownItem,
        BFormDatepicker,
        BFormCheckbox,
        BSpinner,
        BBadge,
        ValidationObserver,
        ValidationProvider,
    },
    directives: {},
    props: {},
    setup(props, context) {
        const dataForm = ref(null)
        const myModal = ref(null)
        const saving = ref(false)
        const serverErrors = ref(null)
        const seasons = ref([])

        const client = ref(JSON.parse(localStorage.getItem('userData')).client)

        const grade = ref({
            id: null,
            season_id: null,
            name: null,
            code: null,
            price: null,
            forGreen: false,
            type: client.value.type !== 0 ? 1 : null,
            isActive: true,
            payable: true,
            variety: null,
        })

        const CROMIS_STORE_MODULE_NAME = 'cromis-grade'

        // Register module
        if (!store.hasModule(CROMIS_STORE_MODULE_NAME)) store.registerModule(CROMIS_STORE_MODULE_NAME, gradesStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(CROMIS_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_STORE_MODULE_NAME)
        })

        onMounted(async () => {
            await store.dispatch('cromis-grade/seasons', { isRunning: 1 })
                .then(response => {
                    seasons.value = response.data.seasons
                    if (seasons.value.length > 0) {
                        grade.value.season_id = seasons.value[0].id
                        changeSeason(grade.value.season_id)
                    }
                })
                .catch(error => {
                    console.log('got error', error)
                })
        })

        const changeSeason = async () => {
            season_id.value = grade.value.season_id
        }

        const {
            fetch,
            columns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,
            isBusy,

            // Filers
            season_id,

            // Resolvers
            resolveStatusVariant,
        } = useGradesList()

        // Form Methods
        const invokeUpdateForm = item => {
            serverErrors.value = null
            console.log(item)
            let price = 0
            if (item.prices.length > 0) {
                price = item.prices[item.prices.length - 1].value
            }

            grade.value = {
                id: item.id,
                season_id: grade.value.season_id,
                name: item.name,
                code: item.code,
                variety: item.variety,
                price,
                forGreen: true,
                payable: item.payable,
                type: item.type,
                isActive: !!item.isActive,
            }

            myModal.value.show()
        }

        const invokeCreateForm = () => {
            serverErrors.value = null

            grade.value = {
                id: null,
                season_id: grade.value.season_id,
                name: null,
                code: null,
                price: null,
                forGreen: true,
                payable: true,
                type: client.value.type !== 0 ? 1 : null,
                variety: null,
                isActive: true,
            }

            myModal.value.show()
        }

        const isFormValid = async () => {
            let isValid = false
            await dataForm.value.validate().then(success => {
                isValid = success
            })

            return isValid
        }

        const submit = bvModalEvt => {
            bvModalEvt.preventDefault()

            serverErrors.value = null
            // Handle form submit
            if (grade.value.id === null || grade.value.id === 0) handleCreate()
            else handleUpdate(grade.value)
        }

        const handleCreate = async () => {
            saving.value = true
            const valid = await isFormValid()

            if (!valid) {
                saving.value = false
                return
            }

            console.log(grade.value)

            await store.dispatch('cromis-grade/create', grade.value)
                .then(response => {
                    refetch()
                    saving.value = false

                    myModal.value.hide()

                    context.root.$swal({
                        icon: 'success',
                        text: `Grade ${response.data.name} registered successfully!`,
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const handleUpdate = async item => {
            saving.value = true
            const valid = await isFormValid()

            if (!valid) {
                saving.value = false
                return
            }

            await store.dispatch('cromis-grade/update', { id: item.id, data: item })
                .then(response => {
                    refetch()
                    saving.value = false

                    myModal.value.hide()

                    context.root.$swal({
                        icon: 'success',
                        text: `Changes to grade # ${response.data.name} has been saved successfully!`,
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const remove = async id => {
            await store.dispatch('cromis-grade/remove', id)
                .then(response => {
                    refetch()
                })
                .catch(error => {
                    context.root.$swal({
                        icon: 'error',
                        title: 'Server Error',
                        text: 'Something went wrong. See tech support',
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: true,
                    })
                })
        }

        return {
            // Data
            seasons,
            grade,
            client,

            fetch,
            columns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,
            isBusy,

            // Methods
            required,
            saving,
            serverErrors,
            dataForm,
            myModal,
            changeSeason,
            invokeCreateForm,
            invokeUpdateForm,
            submit,
            isFormValid,
            handleCreate,
            handleUpdate,
            remove,
            resolveStatusVariant,
        }
    },
}
</script>

<style lang="scss" scoped>
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
